import styled from "styled-components";

import { breakpoints, colors, radii } from "shared/ui/tokens";

export const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 52px;
    padding: 0 4px 0 12px;
    border-radius: ${radii.order};
    /* Без nowrap длинная подпись уносит кнопки на второй ряд, и строка перестаёт читаться. */
    flex-wrap: nowrap;

    &:hover {
        background: rgba(0, 0, 0, 0.02);
    }
`;

// Плашка сжимается до троеточия, а не распирает строку: подпись задаёт заведение.
export const PillWrap = styled.div`
    flex: 0 1 auto;
    min-width: 0;
`;

export const Caption = styled.span`
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${colors.textSecondary};
    font-size: 13px;

    /* На узком экране слот уступает место кнопкам — он виден в форме бейджа. */
    @media (max-width: ${breakpoints.mobile - 1}px) {
        display: none;
    }
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex: none;
    /* Подпись слота скрыта на мобиле — кнопки всё равно держатся справа. */
    margin-left: auto;
`;
